<template>
  <section class="grid-flex column w100">
    <div class="flex w100">
      <div class="flex-1 flex">
        Quantidade de Dashboards: {{ account.used_limits.limit_dash | number }} / {{ account.plan_limits.limit_dash | number }}
        <div style="margin-left: 16px;">Precisa de mais Dashboards? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
      </div>
    </div>
    <div class="box w100 margin-top-s">
      <div class="box-content flex column w100"> 
        <div class="flex flex-1 w100">
          <div class="item flex-1">
            <label>Nome:</label>
            <input class="input margin-top-s" v-model="newDash.name">
          </div>
          <div class="item flex-1">
            <label>Tipo do Dashboard</label>
            <select v-model="newDash.dash_type" class="input margin-top-s">
              <option value="">Seleciona</option>
              <option
                v-for="(f, index) in listTypesDash"
                :key="index"
                :value="f.value"
                :selected="f.value === newDash.dash_type"
              >
                {{ f.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex item margin-top-l">
          <h4>Filtros iniciais para o Dashboard:</h4>
        </div>
        <div class="flex flex-1 w100 margin-top-m">
          <div class="item flex-1">
            <label>Filtro de Data:</label>
            <select v-model="newDash.custom_filters.date" class="input margin-top-s">
              <option value="">Seleciona</option>
              <option
                v-for="(f, index) in listFiltersDate"
                :key="index"
                :value="f.value"
                :selected="f.value === newDash.custom_filters.date"
              >
                {{ f.label }}
              </option>
            </select>
          </div>
          <div class="item flex-1">
            <label>Produto</label>
            <select v-model="newDash.custom_filters.product" class="input margin-top-s">
              <option value="">Todos os Produtos</option>
              <option
                v-for="(f, index) in listFilterProduct"
                :key="index"
                :value="f.value"
                :selected="f.value === newDash.custom_filters.product"
              >
                {{ f.label }}
              </option>
            </select>
          </div>

          <div class="item flex-1">
            <label>Conta de Anúncio</label>
            <select v-model="newDash.custom_filters.mkt_account" class="input margin-top-s">
              <option value="">Todas as Contas</option>
              <option
                v-for="(f, index) in listMktAccounts"
                :key="index"
                :value="f.value"
                :selected="f.value === newDash.custom_filters.mkt_account"
              >
                {{ f.label }}
              </option>
            </select>
          </div>

        </div>
      </div>

    </div>
    <div class="flex w100  margin-top-s">
      <div class="button secondary" style="margin-right: 8px;" @click="$router.back()">Voltar</div>
      <div class="button primary" @click="createOrupdate()" style="margin-right: 8px;">
        {{ isEdit? "SALVAR" : "CRIAR" }} 
      </div>
      <div class="flex-1 w100 flex end">
        <div v-if="isEdit" class="button primary" @click="showModalDelete = true">
          DELETAR
        </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Dashboard?"
      @cancel="
        showModalDelete = false;
      "
      @accept="deleteDashboard()"
    ></modal-confirm>
  </section>
</template>

<script>

import ModalConfirm from "@/components/modal/ModalConfirm";
import { mapState } from "vuex";

import { getFilters } from "@/services/filters";
import { 
  createDashboard,
  getDashboard,
  updateDashboard,
  deleteDashboard
} from "@/services/dashboard";


export default {
  name: "new-dash",
  props: ['dash_id'],
  components: {
    ModalConfirm
  },
  data() {
    return {
      showModalDelete: false,
      newDash : {
        name: '',
        dash_type:'',
        custom_filters: {
          date: 'DAY',
          mkt_account: '',
          product: ''
        }
      },
      listTypesDash: [
        { value: 'PROFIT', label: "Lucratividade"},
        { value: 'SALE', label: "Vendas" },
        { value: 'LEAD', label: "Captação de Leads"},
        { value: 'MESSAGE', label: "Conversas (WhatsApp)"},
      ],
      listFiltersDate: [
        { value: 'DAY', label: "Dia Atual"},
        { value: 'LAST7', label: "Últimos 7 Dias" },
        { value: 'LAST14', label: "Últimos 14 Dias" },
        { value: 'LAST30', label: "Últimos 30 Dias" },
        { value: 'LAST90', label: "Últimos 90 Dias" },
        { value: 'LASTMAX', label: "Máximo" },
      ],
      listFilterProduct: [],
      listMktAccounts: []
    };
  },
  mounted() {
    this.getFilters()

    if (this.isEdit) {
      this.getDashboard()
    }

  },
  watch: {
    'newDash.dash_type': {
      handler() {
        var findType = this.listTypesDash.find(e => e.value === this.newDash.dash_type)
        if (!findType) {
          return
        }

        var findTypeName = this.listTypesDash.find(e => e.label === this.newDash.name)
        if (this.newDash.name && !findTypeName) {
          return
        }

        this.newDash.name = findType.label
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isEdit() {
      return this.dash_id
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_dash <= this.account.used_limits.limit_dash) {
        return true
      }

      return false
    },
  },
  methods: {
    getFilters() {
      getFilters()
        .then((result) => {
          this.listMktAccounts = result.accountAds
          this.listFilterProduct = result.products
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    getDashboard() {
      getDashboard(this.dash_id)
        .then(result => {
          this.newDash = result
        })
        .catch(() =>{
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    createOrupdate() {
      console.log('this.newDash', this.newDash)
      if (this.newDash.id) {
        this.updateDashboard()
      } else {
        this.createDashboard()
      }
    },
    updateDashboard() {
      if (!this.newDash.dash_type) {
        this.$toast.error({
          title:'Erro',
          message:'Preencha o tipo de dashboard'
        })
        return
      }
      var params = {
        name: this.newDash.name,
        dash_type: this.newDash.dash_type,
        custom_filters: this.newDash.custom_filters,
      }
      updateDashboard(this.newDash.id, params)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Dashboard editado com sucesso'
          })

          this.$router.push({ name: "Dash", params: { slug: result.id } });
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocoreu algum problema'
          })
        }) 
    },
    createDashboard() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de dashboards do seu plano! Faça upgrade para criar mais!'
        })
        return
      }

      if (!this.newDash.dash_type) {
        this.$toast.error({
          title:'Erro',
          message:'Preencha o tipo de dashboard'
        })
        return
      }
      var params = {
        name: this.newDash.name,
        dash_type: this.newDash.dash_type,
        custom_filters: this.newDash.custom_filters,
      }
      createDashboard(params)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Dashboard criado com sucesso'
          })

          this.$router.push({ name: "Dash", params: { slug: result.id } });
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocoreu algum problema'
          })
        }) 
    },
    deleteDashboard() {
      deleteDashboard(this.newDash.id)
        .then(() => {
          this.showModalDelete = false
          this.$router.push({ name: "Dash", params: { } });
          this.$toast.success({
            title:'Sucesso',
            message:'Dashboard removido com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    }
  },
};
</script>

<style lang="scss">
</style>
